// Features/Product-Form/mod.ts
import {
  dispatchShowCartNote,
  dispatchCartChange,
  dispatchCartRefresh
} from "Misc";
class Component extends HTMLFormElement {
  connectedCallback() {
    this.addEventListener("submit", this.onSubmit.bind(this));
  }
  async onSubmit(event) {
    event.preventDefault();
    if (!this.checkValidity()) {
      this.reportValidity();
      return;
    }
    this.disableSubmit();
    const form = new FormData(this);
    form.delete("option1");
    form.delete("option2");
    form.delete("option3");
    const url = window.themeVariables.routes.cartAddUrl + ".js";
    const response = await fetch(url, {
      headers: { "X-Requested-With": "XMLHttpRequest" },
      method: "POST",
      body: form
    });
    this.enableSubmit();
    const responseJson = await response.json();
    if (response.ok) {
      const variant = responseJson.hasOwnProperty("items") ? responseJson.items[0] : responseJson;
      this.dispatchEvent(new CustomEvent("Variant:Added", {
        bubbles: true,
        detail: { variant }
      }));
      Cart.query().then((cart) => {
        dispatchCartChange({ cart });
        const openBasket = !window.themeVariables.settings.buyMessage && this.closest(`.drawer`) === null;
        dispatchCartRefresh({ openBasket, cart });
      });
    }
    dispatchShowCartNote(this, {
      status: response.ok ? "success" : "error",
      error: responseJson.description ?? ""
    });
  }
  get submitButtons() {
    return Array.from(this.elements).filter((element) => element instanceof HTMLInputElement || element instanceof HTMLButtonElement).filter((input) => input.type === "submit");
  }
  disableSubmit() {
    for (const button of this.submitButtons) {
      button.setAttribute("disabled", "disabled");
      button.setAttribute("aria-busy", "true");
    }
  }
  enableSubmit() {
    for (const button of this.submitButtons) {
      button.removeAttribute("disabled");
      button.removeAttribute("aria-busy");
    }
  }
}
window.customElements.define("product-form", Component, { extends: "form" });
export {
  Component as ProductForm
};
